import React from 'react'
import { url } from '../../constants/url';
import { toast } from 'react-toastify';

function DeleteReport({ fetchDocument, setConfirmDelete, singleProjectData, selectedFileName}) {

    const handleDeleteReport = async () => {
        try {
          const response = await fetch(`${url}/deletereports`, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
              fileName: selectedFileName,
              projectId: singleProjectData._id
            })
          });
    
          if (response.ok) {
            toast.success("Report deleted successfully", {
              position: "top-right",
              autoClose: 2500,
              pauseOnHover: false,
            });
            setConfirmDelete(false)
            fetchDocument()

            return
          }
    
          if (response.status === 400) {
            toast.error("Invalid details", {
              position: "top-right",
              autoClose: 2500,
              pauseOnHover: false,
            });
            setConfirmDelete(false)
            return
          }
    
        } catch (error) {
          console.error('Delete error:', error);
          alert('An error occurred while deleting the report.');
        }
      };

    return (
        <div className='delete-container'>
            <div className='delete-content'>
                <div className='delete-header'>
                    <p>Delete!</p>
                </div>
                <div className='delete-body'>
                    <div className='delete-message'>
                        <p>Are you sure you want to delete?</p>
                    </div>
                    <div className='delete-buttons'>
                        <button className='delete-btn cancel' onClick={() => setConfirmDelete(false)}>
                            Cancel
                        </button>
                        <button className='delete-btn confirm' onClick={() => {
                            handleDeleteReport(selectedFileName)
                        }}>
                            Delete
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DeleteReport
